<template>
<el-container :class="{'pc_cancel_button': !ismobile, 'mobile_cancel_button':ismobile}">
  <div class="button-detail">
    <el-button class="cancel_order_button" @click="openCancelDia()">{{$t('cancel')}}</el-button>
  </div>
  <!--取消订单-->
  <el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="openCancel" :width="diaWidth">
    <div slot="title" style="font-size: 20px; font-weight: 650;color:#333333;">{{$t('cancel')}}</div>
    <div class="dia-content">
      <div style="height: 50px;line-height: 50px;">{{$t('orderCancelReason')}}<span style="color:red;">*</span></div>
      <div class="el-form-item__content">
        <el-select v-model="reason" @focus="setOptionWidth" style="width:100%" @change="reasonChange" v-if="language === 'zh'">
          <el-option v-for="(item, id) in reasons" :key="item" :style="{ width: `${selectOptionWidth}px` }" :label="item" :value="id" :class="{'mobile-select': ismobile}">
          </el-option>
        </el-select>
        <el-select v-model="reason" @focus="setOptionWidth" style="width:100%" @change="reasonChange" v-else>
          <el-option v-for="(item, id) in reasonsEn" :key="item" :style="{ width: `${selectOptionWidth}px` }" :label="item" :value="id" :class="{'mobile-select': ismobile, 'twoline': ismobile && (id === 4 || id === '4')}">
            <span>{{item}}</span>
          </el-option>
        </el-select>
      </div>
      <div style="color:red; margin-top:10px;" v-show="reasonMust">{{$t('selectCancelReason')}}</div>
      <div class="el-input" :class="{'otherreason-msg': otherReasonMsg}" style="margin-top:8px;" v-show="otherReason">
        <textarea ref="otherreason" autocomplete="off" placeholder="" maxlength="200" class="el-textarea__inner" style="min-height: 100px;"></textarea>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="dialog-close" @click="openCancel = false">{{$t('close')}}</el-button>
      <el-button class="dialog-cancel" type="primary" @click="cancelContinue">{{$t('continueCancel')}}</el-button>
    </div>
  </el-dialog>
  <!--取消订单失败-->
  <el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelFailed" :width="diaWidth">
    <div style="text-align:center;">
      <div class="order-status-img" style="width:70px;height:70px;background:red;border-radius: 50%; margin:0 auto;">
        <img style="width:40px; height:40px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
      </div>
      <div stype="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
        <div style="margin:25px 0px; font-size: 18px;">
          {{$t('orderCancelfaild')}}
        </div>
        <div class="cancelmsg-text">
          {{$t('contactCustomer')}}
        </div>
        <div class="cancelmsg-text">
          {{$t('contactEmail')}}cs_client@51smart.com
        </div>
        <div class="cancelmsg-text">
          {{$t('phoneNumberTwo')}}0086-0411-84949537
        </div>
      </div>
    </div>
  </el-dialog>
</el-container>
</template>

<script>
import { getCancelPriceDetail, orderCancel } from '@/request/order.js'
export default {
  name: 'OrderCancel',
  props: ['source', 'ismobile', 'noPayCancel', 'conver'],
  components: {
    getCancelPriceDetail,
    orderCancel
  },
  data () {
    return {
      showClo: false,
      reason: '',
      reasons: {'1': '被迫取消或延期行程', '2': '在网络上查询到更便宜的酒店价格', '3': '将与酒店直接预订', '4': '预订信息填写有误，希望取消重订', '5': '网站无法确认', '50': '其它'},
      reasonsEn: {'1': 'Forced to cancel or postpone trip', '2': 'Found lower price on the internet', '3': 'Will book with hotel directly', '4': 'Will rebook because of wrong booking information submitted', 5: 'The website is unable to confirm', '50': 'Other'},
      openCancel: false,
      diaWidth: '500px',
      selectOptionWidth: '460',
      reasonMust: false,
      otherReasonMsg: false,
      otherReason: false,
      refundDetail: [],
      cancelFailed: false,
      orderstatus: '',
      currency: this.common.currencySet(this),
      language: this.common.languageSet(this)
    }
  },
  watch: {},
  created () {},
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.reportNoShow = false
      this.reportShow = false
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
  },
  methods: {
    setOptionWidth (event) {
      if (this.ismobile === true) {
        this.selectOptionWidth = event.view.innerWidth * 0.95 - 40
      }
    },
    reasonChange () {
      if (this.reason !== '50') {
        this.otherReason = false
      } else {
        this.otherReason = true
      }
      this.reasonMust = false
    },
    openCancelDia () {
      this.openCancel = true
    },
    cancelContinue () {
      if (this.reason === '' || this.reason === undefined) {
        this.reasonMust = true
      } else if (this.reason === 50 || this.reason === '50') {
        var otherreason = this.$refs['otherreason'].value
        if (otherreason === '' || otherreason === 'null' || otherreason === undefined) {
          // 提醒
          this.otherReasonMsg = true
          return true
        } else {
          this.otherReasonMsg = false
          this.doCancel()
        }
      } else {
        this.otherReasonMsg = false
        this.doCancel()
      }
    },
    doCancel () {
      if (this.clickCancel === false) {
        return false
      }
      this.clickCancel = false
      var orderno = this.common.linkQuerys.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var otherreason = this.$refs['otherreason'].value
      if (this.reason === '' || (this.reason === '5' && otherreason === '')) {
        this.openCancel = true
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'reason': this.reason,
        'otherreason': otherreason,
        'orderstatus': 1, // 待支付
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      orderCancel(data).then(res => {
        this.clickCancel = true
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          // 取消订单成功
          // this.$router.push({name: 'PayCallbackResult', query: {'orderno': res.data.orderno}})
          let newQuerys = this.common.linkEncode({'orderno': res.data.orderno, 'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'orderno': res.data.orderno, 'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'PayCallbackResult', params: {'querys': newQuerys}})
        } else {
          // 取消订单失败
          this.openCancel = false
          this.cancelFailed = true
        }
      })
    },
    refreshUrl () {
      window.location.reload()
    }
  },
  computed: {}
}
</script>

<style scoped>
/*取消订单*/
.cancel_order_button{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border-width: 1px;border-style: solid;border-color: rgba(225, 226, 239, 1);border-radius: 6px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 650;font-style: normal;font-size: 16px;color: #4F4C4C;width:100%;height:51px;}
.cancel_order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
.cancel_order_button:focus{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}

.pc_cancel_button{width: 30%;display: inline-block;margin-right: 10px;}
.mobile_cancel_button{width: 100%;display: inline-block;margin-top: 10px;}

/* 取消订单弹框 */
.dia-price{font-weight:100;height:50px;line-height: 25px; margin:10px 0px;border-bottom: 1px solid rgba(215, 215, 215, 1);}
.dia-content{padding:0px 20px 50px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
.dia-content-continue{padding:50px 20px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
.dialog-close{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
.dialog-close:focus{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
.dialog-cancel, .dialog-cancel:focus{width: 30%;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dia-content input:focus,.el-select /deep/ .el-input.is-focus .el-input__inner,.el-select /deep/ .el-input__inner:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.cancelYes, .dialog-cancel:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border: 1px solid rgba(252, 210, 5, 1);}
.open-dia /deep/ .el-button+.el-button{margin-left:0px;}
.open-dia /deep/ .el-button:hover{background-color:rgba(252, 210, 5, 1); color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.otherreason-msg{border:1px solid red;}
.open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;text-align: left}
.open-dia /deep/ .el-dialog__header{padding: 20px 20px;height: 40px;font-size: 22px;font-weight: 650;line-height: 40px;text-align: left}
.button-detail{margin-bottom: 10px;}
.button-detail .gray-color{ background:rgba(221, 223, 226, 1);}
.button-detail .gray-color:hover{background:rgba(221, 223, 226, 1);}
.cancelmsg-text{ margin-bottom:10px; font-size:13px; overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;}

/* 取消订单弹框 */
.dia-price{font-weight:100;height:50px;line-height: 25px; margin:10px 0px;border-bottom: 1px solid rgba(215, 215, 215, 1);}
.dia-content{padding:0px 20px 50px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
.dia-content-continue{padding:50px 20px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
.dialog-close{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
.dialog-close:focus{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
.dialog-cancel, .dialog-cancel:focus{width: 30%;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dia-content input:focus,.el-select /deep/ .el-input.is-focus .el-input__inner,.el-select /deep/ .el-input__inner:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.cancelYes, .dialog-cancel:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border: 1px solid rgba(252, 210, 5, 1);}
.open-dia /deep/ .el-button+.el-button{margin-left:0px;}
.open-dia /deep/ .el-button:hover{background-color:rgba(252, 210, 5, 1); color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.otherreason-msg{border:1px solid red;}
.open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;}
.open-dia /deep/ .el-dialog__header{padding: 20px 20px;height: 40px;font-size: 22px;font-weight: 650;line-height: 40px;}
.button-detail .gray-color{ background:rgba(221, 223, 226, 1);}
.button-detail .gray-color:hover{background:rgba(221, 223, 226, 1);}
.cancelmsg-text{ margin-bottom:10px; font-size:13px; overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;}

/* mobile */
.twoline{ height: 40px; line-height: 20px; white-space: inherit;}
.el-descriptions__table tr{ height: 32px;}
/* 响应式 */
@media only screen and (max-width:1099px){
  .mobile-select{ border-bottom: 1px solid rgba(221, 223, 226, 0.2980392156862745);}
  .dialog-close{width: 75px;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333; text-align:center;}
  .dialog-close:focus{width: 75px;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
  .dialog-cancel, .dialog-cancel:focus{width: 35%; background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF; text-align:center;}
  .open-dia /deep/ .el-dialog{ -webkit-backface-visibility: hidden; }
  .dia-content /deep/ .el-dialog{ -webkit-backface-visibility: hidden; }
}
</style>



// WEBPACK FOOTER //
// src/components/order/module/OrderCancel.vue